/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelPropertyContentAddress
 */
export interface HotelPropertyContentAddress {
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    stateCode?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentAddress
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the HotelPropertyContentAddress interface.
 */
export function instanceOfHotelPropertyContentAddress(value: object): value is HotelPropertyContentAddress {
    return true;
}

export function HotelPropertyContentAddressFromJSON(json: any): HotelPropertyContentAddress {
    return HotelPropertyContentAddressFromJSONTyped(json, false);
}

export function HotelPropertyContentAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelPropertyContentAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line_1'] == null ? undefined : json['line_1'],
        'line2': json['line_2'] == null ? undefined : json['line_2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'stateCode': json['state_code'] == null ? undefined : json['state_code'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['country_code'] == null ? undefined : json['country_code'],
    };
}

export function HotelPropertyContentAddressToJSON(json: any): HotelPropertyContentAddress {
    return HotelPropertyContentAddressToJSONTyped(json, false);
}

export function HotelPropertyContentAddressToJSONTyped(value?: HotelPropertyContentAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line_1': value['line1'],
        'line_2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'state_code': value['stateCode'],
        'postal_code': value['postalCode'],
        'country': value['country'],
        'country_code': value['countryCode'],
    };
}

